export default {
  // 资产信息
  totalAsset: "总资产（可用余额）",
  updated: "更新",

  // Tooltip提示
  assetBalanceTooltip:
    "地址总资产余额是根据本系统已收录的币种价值，按地址持有的所有主币和代币折算USDT的总余额",
  systemSupport: "系统当前已支持",
  supportedCurrencies: "317个币种",
  tronSupport: "Tron链币种数据当前仅支持TRX、USDT",

  // 黑名单标签
  usdtBlocked: "# USDT BLOCKED",
  usdcBlocked: "# USDC BLOCKED",

  // Tron 数据计算
  tronCalculating: "Tron数据计算中，请稍后查看",

  // 弹窗标题
  assetBalanceChange: "总资产余额变化",
};
